<div *ngIf="product.loading" class="mb-5">
  <div class="spinner spinner-sm">
    <div class="lspinner"></div>
  </div>
  <div class="text-center">Access section is loading</div>
</div>

<re-collapsible-group *ngIf="product?.display" [header]="product?.productName" [(isCollapsed)]="product.collapsed">

  <ng-container re-cg-title-right-content>

    <!--<div class="">
      <span *ngIf="product?.userStatus == 1" class="badge badge-primary"><span class="m-2">Provisioning in progress</span></span>
      <span *ngIf="product?.userStatus == 2" class="badge badge-danger"><span class="m-2">User not provisioned</span></span>
      <span *ngIf="product?.userStatus == 3" class="">
        <span class="fa fa-check text-success provisioned-icon"></span>
        <span class="fa fa-user ml-2 provisioned-icon"></span>
        <span class="ml-3">User is provisioned</span>
      </span>
    </div>-->

  </ng-container>

  <ng-content select="[re-pi-content]">

  </ng-content>

  <ng-container>

    <div *ngIf="product?.userStatus==1">
      *Deeplink for additional user provisioning will appear here once user is provisioned in {{product?.productName}} Section and you see a green check mark at the top right.
    </div>
    <div *ngIf="product?.userStatus==2 && product?.editUserUrl" class="text-danger">
      <span *ngIf="showLinks">*User was not provisioned, please create user manually by going to <a target="_blank" [attr.href]="product?.editUserUrl|keepHtml:'url'">{{product?.productName}} Section.</a></span>
      <span *ngIf="!showLinks">*User was not provisioned, please create user manually by going to {{product?.productName}}.</span>
    </div>
    <div *ngIf="product?.userStatus==3 && product?.editUserUrl">
      <span *ngIf="showLinks">To configure roles, permissions and location, please go to <a target="_blank" [attr.href]="product?.editUserUrl|keepHtml:'url'">{{product?.productName}} Section</a>.</span>
      <span *ngIf="!showLinks">To configure roles, permissions and location, please go to {{product?.productName}}.</span>
    </div>
  </ng-container>
</re-collapsible-group>


